<template>
  <div class="welcome">
    <el-form ref="addForm" :model="addForm" label-width="120px">
      <el-form-item label="客户" class="workNumer">
        <el-select v-model="addForm.customer" placeholder="请选择" @change="customerChange">
          <el-option :label="item.name" :value="item.id" v-for="item in customers"
            :key="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户联系人" class="workNumer">
        <el-select v-model="addForm.contact" placeholder="请选择">
          <el-option :label="item.name" :value="item.id" v-for="item in contacts"
            :key="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btn">
        <el-button type="primary" size="small" class="search" @click="bindCustomerContack">客户联系人绑定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Sign',
  data() {
    return {
      customers: [],
      contacts: [],
      input: '',
      addForm: {
        customer: '',
        contact: ''
      }
    }
  },
  mounted() {
    this.$root.$children[0].sign('http://17l.link/dist/?id=1&targetName=Invoice&wechatLogin=true&state=123')
    if (this.$common.session.get('thirdForm')) {
      this.addForm = this.$common.session.get('thirdForm')
      if (this.addForm.customer && this.addForm.contact && this.$route.params.code) {
        this.bindCustomerContack()
      }
      this.queryCustomerByCid(this.addForm.customer, this.addForm.contact)
    } else {
      this.queryCustomerByCid()
    }
  },
  methods: {
    // 查询公司（客户）
    queryCustomerByCid(customer, contact) {
      const param = {
        cid: this.$route.params.id
      }
      this.$get('/customer/queryCustomerByCid', param).then(
        result => {
          if (result.status === 200) {
            this.customers = result.data
            this.queryContact(customer, contact)
          } else {
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    },
    customerChange(val) {
      if (val) {
        this.queryContact(val)
      }
    },
    // 查询公司（客户）
    queryContact(id, contact) {
      if (!id) {
        return
      }
      console.log(id, contact)
      const param = {
        id: id
      }
      this.$get('/customer/queryContact', param).then(
        result => {
          if (result.status === 200) {
            this.contacts = result.data
            this.addForm.contact = contact || ''
          } else {
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    },
    // 绑定客户
    bindCustomerContack(id) {
      const param = {
        id: this.addForm.contact,
        code: this.$route.params.code
      }
      this.$common.session.set('thirdForm', this.addForm)
      if (!this.addForm.contact) {
        return this.$toast('请选择客户联系人')
      }
      this.$common.session.set('thirdForm', this.addForm)
      if (!this.$route.params.code) {
        window.location.href = './?wechatLogin=true&targetName=Third&id=' + this.$route.params.id + '&state=111'
        return
      }
      this.$get('/customer/bindCustomerContact', param).then(
        result => {
          if (result.status === 200) {
            const targetName = this.$common.session.get('ThirdTargetName') || 'Invoice'
            window.location.href =
              './?wechatLogin=true&targetName=' + targetName + '&id=' + this.$route.params.id + '&state=111'
          } else {
            this.$dialog
              .alert({
                message: result.msg
              })
              .then(() => {
                window.location.href = './?wechatLogin=true&targetName=Third&id=' + this.$route.params.id + '&state=111'
              })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    }
  },
  destroyed() {}
}
</script>

<style lang="less" scoped>
.welcome {
  padding: 5vw;
  box-sizing: border-box;
  .img-box {
    display: flex;
    flex-wrap: wrap;
    .img {
      img {
        max-width: 200px;
      }
    }
  }
  .scan-icon {
    padding-top: calc(50vh - 20vw);
    text-align: center;
    color: #10a60e;
    /deep/.van-icon-scan {
      font-size: 30vw;
    }
  }
}
</style>
